import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AuditCaseDetailPage = lazy(() => import("@/features/audit-response/pages/audit-case-detail"));

export const Route = createFileRoute("/(app)/dashboard/audit-response/$caseId")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading case...</div>}>
      <AuditCaseDetailPage />
    </Suspense>
  ),
});
